export default __webpack_public_path__ + "static/media/architecture.2f40f311.svg";